import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import React, { useEffect } from "react";
import BookingExportsTable from "../../../components/tables/BookingExportsTable.jsx";
import { Box, Typography } from "@mui/material";

const breadcrumbs = [
  { name: "Home", path: "/home" },
  {
    name: "Buchungsverwaltung",
    path: "/admin/buchungen",
  },
  {
    name: "Buchungsexporte",
    path: "/admin/buchungen/exports",
  },
];

export default function BookingExportIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs(breadcrumbs);
  }, [setBreadcrumbs]);

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2">
          Hier finden Sie eine Übersicht aller exportierten ausgehenden
          Buchungen. Die Buchungen werden in Paketen gebündelt, um sie an
          Zahlungsdienstleister zu übermitteln und somit die Auszahlungen durchzuführen.
        </Typography>
      </Box>

      <BookingExportsTable />
    </>
  );
}
